import { Workflow } from "@finway-group/shared/lib/models"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { WorkflowService } from "~Shared/services/workflowService"
import { store } from "~Shared/store"
import { type RootState } from "~Shared/store/rootState.interface"

export const useWorkflows = (searchValue?: string) => {
    const workflows = useSelector(({ workflows: { items } }: RootState) => items)
    return filterWorkflows(workflows, searchValue)
}

export const getWorkflowsFromStore = (searchValue?: string) => {
    const workflows = store.getState().workflows.items
    return filterWorkflows(workflows, searchValue)
}

export const useWorkflowById = (id?: string | null, searchValue?: string) => {
    const [fetchedWorkflow, setFetchedWorkflow] = useState<Workflow | undefined>(undefined)
    const workflows = useWorkflows(searchValue)
    const isInStore = workflows.some((workflow) => workflow._id === id)

    useEffect(() => {
        if (!id || isInStore) {
            return
        }
        let isCurrent = true
        WorkflowService.fetchOneWorkflow(id).then((workflow) => isCurrent && setFetchedWorkflow(workflow))
        return () => {
            isCurrent = false
        }
    }, [id])

    return resolveWorkflowById(id, workflows, fetchedWorkflow)
}

/** @returns the workflow with `id` from the store, else the fetched one only if it is that same workflow */
export const resolveWorkflowById = (id: string | null | undefined, workflows: Array<Workflow>, fetchedWorkflow: Workflow | undefined) => {
    if (!id) {
        return undefined
    }
    return workflows.find((workflow) => workflow._id === id) ?? (fetchedWorkflow?._id === id ? fetchedWorkflow : undefined)
}

export const getWorkflowById = (id?: string | null) => (id ? new Workflow(store.getState().workflows.items.find((workflow: any) => workflow._id === id)) : undefined)

const filterWorkflows = (workflows: Array<any>, searchValue: any): Array<Workflow> => {
    if (searchValue) {
        workflows = workflows?.filter((workflow: Workflow) => workflow.name.toLowerCase().includes(searchValue.toLowerCase()))
    }

    return workflows.map((workflow) => new Workflow(workflow)).sort((workflowA: any, workflowB: any) => workflowA.order - workflowB.order)
}

export const useWorkflow = () => useSelector(({ workflows: { item } }: RootState) => item)
